import { useState } from 'react'
import ListingCard from '../ListingCard/ListingCard'
import Footer from '../Footer/Footer'
import './Favorites.css'

const PER_PAGE = 10

export default function Favorites({
  listings        = [],
  wishlist        = [],
  onFav           = () => {},
  onDetail        = () => {},
  onBack          = () => {},
  onCategoryClick = () => {},
}) {
  const [currentPage, setCurrentPage] = useState(1)
  const favListings = listings.filter(l => wishlist.includes(l.id))
  const totalPages  = Math.max(1, Math.ceil(favListings.length / PER_PAGE))
  const paginated   = favListings.slice((currentPage - 1) * PER_PAGE, currentPage * PER_PAGE)

  return (
    <div className="fav-page">

      {/* Header */}
      <div className="fav-header">
        <div className="fav-header-inner">
          <button className="fav-back" onClick={onBack}>← Retour</button>
          <div>
            <h1 className="fav-title">❤️ Mes Favoris</h1>
            <p className="fav-sub">
              {favListings.length > 0
                ? `${favListings.length} annonce${favListings.length > 1 ? 's' : ''} sauvegardée${favListings.length > 1 ? 's' : ''}`
                : 'Aucun favori pour le moment'
              }
            </p>
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="fav-content">
        {favListings.length === 0 ? (
          <div className="fav-empty">
            <div className="fav-empty-icon">🤍</div>
            <div className="fav-empty-title">Aucun favori pour le moment</div>
            <div className="fav-empty-sub">
              Cliquez sur le cœur ❤️ sur une annonce pour la sauvegarder ici.
            </div>
            <button className="fav-empty-btn" onClick={onBack}>
              Parcourir les annonces
            </button>
          </div>
        ) : (
          <>
            <div className="fav-grid">
              {paginated.map(listing => (
                <ListingCard
                  key={listing.id}
                  listing={listing}
                  isFav={true}
                  onFav={() => onFav(listing.id)}
                  onDetail={() => onDetail(listing.id)}
                />
              ))}
            </div>

            {totalPages > 1 && (
              <div className="fav-pagination">
                <button
                  className="fav-pg-btn"
                  disabled={currentPage === 1}
                  onClick={() => { setCurrentPage(p => p - 1); window.scrollTo(0, 0) }}
                >←</button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                  <button
                    key={p}
                    className={`fav-pg-btn${currentPage === p ? ' active' : ''}`}
                    onClick={() => { setCurrentPage(p); window.scrollTo(0, 0) }}
                  >{p}</button>
                ))}
                <button
                  className="fav-pg-btn"
                  disabled={currentPage === totalPages}
                  onClick={() => { setCurrentPage(p => p + 1); window.scrollTo(0, 0) }}
                >→</button>
                <span className="fav-pg-info">
                  {(currentPage - 1) * PER_PAGE + 1}–{Math.min(currentPage * PER_PAGE, favListings.length)} / {favListings.length}
                </span>
              </div>
            )}
          </>
        )}
      </div>

      <Footer onCategoryClick={onCategoryClick} />
    </div>
  )
}